import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../../Reusable/Table/Table1";
import {
  PlusCircleOutlined,
  EditOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import EditableTable from "../../Reusable/Table/EditableTable";
import DropdownButton from "../../Reusable/dropdown/Drop";
import ReusableModal from "../../Reusable/Model/Model";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import { Form, Input, Radio, InputNumber, Tag, Segmented, Select, Modal, Checkbox } from "antd";
import { Row, Col, Image } from "antd";
import { Button, App } from "antd";
import CustomSelect from "../../Reusable/Select/Select";
import AvatarUploader from "../../Reusable/Avatar/Avatar";
import axios from "axios";
import consts from "../../constant";
import Loadingpage from "../Loadingpage/Loadingpage";
import log from "../../assets/logo.png";
import normalImg from "../../assets/react.svg"
import { deletePair } from "../../services/pairsService";

const Pairs = () => {

  const { modal, message } = App.useApp();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openBlock, setOpenBlock] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState("Content of the modal");
  const [totalPage, setTotalPage] = useState([]);
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [trade, setTrade] = useState(null);
  const [filter, setFilter] = useState(null);
  const [pairStatus, setPairStatus] = useState("all");
  const { Search } = Input;
  // table data
  const [assets, setAssets] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState("");

  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleOkBlock = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenBlock(false);
      setConfirmLoading(false);
      success();
    }, 2000);
  };

  const handleDelete = async (id) => {
    try {
      modal.confirm({
        title: 'Warning',
        content: `Are you sure you want to delete this pair?`,
        okText: 'Yes, Delete',
        cancelText: 'Cancel',
        centered: true,
        onOk: async () => {
          await deletePair(id);
          message.success("Pair deleted successfully");
          getCurrentPair();
        }
      });

    } catch (error) {
      message.error("Failed to delete pair");
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelBlock = () => {
    setOpenBlock(false);
  };

  const userColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    {
      title: "Symbol  Image",
      dataIndex: "symbolimg",
      key: "symbolimg",
      render: (img) => (
        <img
          src={img}
          alt="symbol"
          style={{ width: 40, height: 40, objectFit: "contain" }}
        />
      ),
    },

    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (value) => {
        if (!value) return null;
        const val = value.toLowerCase();
        if (val === "future") return <Tag color="orange">Future</Tag>;
        if (val === "crypto") return <Tag color="green">Crypto</Tag>;
        if (val === "forex") return <Tag color="red">Forex</Tag>;
        return <Tag color="blue">Commodity</Tag>;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        return value === "active" ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">In-Active</Tag>
        );
      },
    },

    {
      title: "Action",
      key: "select",
      // fixed: "right",
      render: (_, record) => (
        <>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => navigate(`/${consts.route}/pairs/edit/${record._id}`)}
            style={{ color: "#2eff0c" }}
          >
            Edit
          </Button>
          <Button
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record._id)}
            style={{ color: "#ff0000" }}
          >
            Delete
          </Button>
        </>
      ),
    },
  ];


  const handleClear = () => {
    setTrade(undefined);
    setFilter(undefined);
    setPairStatus(undefined);
  }


  const success = () => {
    message.open({
      type: "success",
      content: "User Blocked",
    });
  };



  const getCurrentPair = async () => {
    setConfirmLoading(true);
    try {
      let typeMap = {
        highlow: "highLow",
        updown: "upDown",
        highlowspread: "highLowSpread",
        taptrade: "tapTrade"
      };

      let coinMap = {
        crypto: "CRYPTO",
        forex: "FOREX",
        future: "FUTURE",
        commodity: "COMMODITIES"
      };

      let payload = {};

      if (typeof search === "string" && searchTrigger.trim() !== "") {
        payload.search = searchTrigger;
      }

      if (filter && filter !== "all") {
        payload.type = coinMap[filter] || filter;
      }

      if (pairStatus && pairStatus !== "all") {
        payload.status = pairStatus === "active" ? true : false;
      }


      const { data } = await axios.post(
        `${consts.BackendUrl}/get-pairs?limit=${page?.pageSize || 10}&page=${page?.current || 1}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
          },
        }
      );

      if (data?.success === true && data?.result?.docs?.length > 0) {
        var dts = data?.result?.docs;
        var totalCount = data?.result?.totalDocs;
        // Map backend data into the table format
        const mappedData = dts.map((user, index) => ({
          key: user?._id || index, // must be unique
          sno: page?.current
            ? (page?.current - 1) * (page?.pageSize || 10) + index + 1
            : index + 1,
          symbolimg: user?.icon || log,
          symbol: user?.pair_symbol?.replace("_", "") || user?.base_asset_name,
          type: user?.type,
          status: user?.status ? "active" : "inactive",
          _id: user?._id,
        }));

        setTotalPage(totalCount);
        setAssets(mappedData);
      } else {
        setAssets([]);
        setTotalPage(0);
      }
    } catch (error) {
      setAssets([]);
      setTotalPage(0);
      console.log(error?.response?.data?.message, "error");
    }
    setConfirmLoading(false);
  };


  const handlePagination = (pagination) => {
    setPage(pagination);
  }

  useEffect(() => {
    getCurrentPair();
  }, [page, pairStatus, trade, filter, searchTrigger]);

  return (
    <>
      <Loadingpage />
      <div className="display-2 responsive-group p-10">
        <h2>Pair List</h2>

        <div className="display-1 responsive-inputgroup">
          <Search
            placeholder="Search for symbol"
            onChange={(e) => {
              const value = e.target.value;

              setSearch(value);

              // clear icon click
              if (!value) {
                setSearchTrigger("");

                setPage({
                  current: 1,
                  pageSize: 10,
                });
              }
            }}
            onSearch={(value) => {
              setPage({
                current: 1,
                pageSize: 10,
              });

              setSearchTrigger(value);
            }}
            value={search}
            allowClear
            style={{ width: 200 }}
            loading={confirmLoading}
            className="input-cls"
          />

          <div className="display-1">

            <Select
              allowClear
              placeholder="Status"
              value={pairStatus}
              style={{ width: 150 }}
              onChange={(e) => {
                setPairStatus(e);
                setPage({ current: 1, pageSize: 10 });
              }}
            >
              <Select.Option value={"all"}>All</Select.Option>
              <Select.Option value={"active"}>Active</Select.Option>
              <Select.Option value={"inactive"}>In Active</Select.Option>
            </Select>
          
            <Select
              allowClear
              value={filter}
              onChange={(e) => {
                setFilter(e);
                setPage((prev) => ({ ...prev, current: 1 }));
              }}
              placeholder="Type"
              style={{ minWidth: 150 }}
            >
              <Select.Option value={"all"}>All</Select.Option>
              <Select.Option value={"forex"}>Forex</Select.Option>
              <Select.Option value={"crypto"}>Crypto</Select.Option>
              <Select.Option value={"future"}>Future</Select.Option>
              <Select.Option value={"commodity"}>Commodity</Select.Option>
            </Select>
            <Button
              style={{ marginLeft: 10 }}
              disabled={confirmLoading}
              icon={<CloseCircleOutlined />}
              onClick={() => {
                setSearch("");
                setSearchTrigger("");
                setFilter(undefined);
                setPairStatus(undefined);
                setPage({ current: 1, pageSize: 10 });
              }}
            >
              Clear
            </Button>

            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={() => navigate(`/${consts.route}/pairs/create`)}
              style={{ padding: "18px 10px" }}
            >
              Create Pair
            </Button>

            {/* <Button icon={<CloseCircleOutlined />} onClick={handleClear}>
              Clear
            </Button> */}
          </div>

        </div>
      </div>
      <EditableTable
        columnsConfig={userColumns}
        dataSource={assets}
        className="mt-20"
        total={totalPage} // 👈 pass backend total here
        pageSize={page?.pageSize ? page?.pageSize : 10}
        current={page?.current ? page?.current : 1}
        closeDisabled={true}
        onChange={handlePagination}
        loading={ confirmLoading }
      // completeTrade={editTrade}
      // newValues={newValues}
      />

      <ReusableModal
        title="Confirm Delete"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </ReusableModal>
      <ReusableModal
        title="Confirm Block"
        open={openBlock}
        onOk={handleOkBlock}
        confirmLoading={confirmLoading}
        onCancel={handleCancelBlock}
      >
        <p>{modalText}</p>
      </ReusableModal>

    </>
  );
};

export default Pairs;
